



















import { Component, Vue, Prop } from 'vue-property-decorator';
import { State } from 'vuex-class';

@Component
export default class THead extends Vue {
	@Prop() private columns!: any;
	@Prop() private tableState!: string;
	@Prop() private selectedColumn!: string;

	@State private totalRows!: number;

	public getSelected() {
		for (let i = 0; i < this.columns.length; i++) {
			const col = this.columns[i];
			if (col.name === this.selectedColumn) {
				return (this.$refs[`col_${i}`] as any)[0];
			}
		}
	}
}
